export const VEHICLE_LIST = [
   {
        VehicleID:2,
        Make: "Toyota",
        Model: "Prius",
        LicencePlate:"TA41III",

        VehicleType:"TAXI",
        SkillType:"JUNIOR",
        EstimatedHours:"3",
        PriorityType:"STANDARD",

        installerID:10,
        JobID:1,
        tenantID:null,
    },    
    {
        VehicleID:3,
        Make: "Toyota",
        Model: "Prius",
        LicencePlate:"SG57ZBH",

        VehicleType:"TAXI",
        SkillType:"JUNIOR",
        EstimatedHours:"3",
        PriorityType:"STANDARD",

        installerID:11,
        JobID:1,
        tenantID:null,
    },     
    {
        VehicleID:4,
        Make: "Toyota",
        Model: "Prius",
        LicencePlate:"SH2JKR",

        VehicleType:"TAXI",
        SkillType:"JUNIOR",
        EstimatedHours:"3",
        PriorityType:"STANDARD",
        
        installerID:11,
        JobID:1,
        tenantID:null,
    },
    {
        VehicleID:5,
        Make:"Vauxhall",
        Model:"Vivaro",
        LicencePlate:"DN15ZTB",

        VehicleType:"VAN",
        SkillType:"JUNIOR",
        EstimatedHours:"3",
        PriorityType:"HIGH",
        
        installerID:11,
        JobID:2,
        tenantID:null,
    },
    {
        VehicleID:5,
        Make:"Lamborghini",
        Model:"Lamborghini Aventador LP720",
        LicencePlate:"LA1",

        VehicleType:"CAR",
        SkillType:"TRAINEE",
        EstimatedHours:"1",
        PriorityType:"STANDARD",
        
        installerID:12,
        JobID:3,
        tenantID:null,
    },
    {
        VehicleID:6,
        Make:"Ford",
        Model:"Focus",
        LicencePlate:"SG13UDT",

        VehicleType:"CAR",
        SkillType:"JUNIOR",
        EstimatedHours:"2",
        PriorityType:"STANDARD",
        
        installerID:10,
        JobID:3,
        tenantID:null,
    },
    {
        VehicleID:7,
        Make:"DeLorean",
        Model:"DMC-12 1981",
        LicencePlate:"OUTATIME",

        VehicleType:"CAR",
        SkillType:"INTERMEDIATE",
        EstimatedHours:"5",
        PriorityType:"LOW",
        
        installerID:2,
        JobID:5,
        tenantID:null,
    },
    {
        VehicleID:8,
        Make:"Dodge",
        Model:"A100",
        LicencePlate:"AC-712",

        VehicleType:"VAN",
        SkillType:"TRAINEE",
        EstimatedHours:"7",
        PriorityType:"IMMEDIATE",
        
        installerID:9,
        JobID:6,
        tenantID:null,
    },
    {
        VehicleID:9,
        Make: "Chevrolet",
        Model: "Express",
        LicencePlte:"720SAD",

        VehicleType:"SOFTPLAY",
        SkillType:"JUNIOR",
        EstimatedHours:"100",
        PriorityType:"HIGH",
        
        installerID:9,
        JobID:7,
        tenantID:null,
    },
    {
        VehicleID:10,
        Make:"Porsche",
        Model:"Taycan",
        LicencePlate:"WR4P53",

        VehicleType:"CAR",
        SkillType:"INTERMEDIATE",
        EstimatedHours:"8",
        PriorityType:"LOW",
        
        installerID:null,
        JobID:8,
        tenantID:null,
    },
    {
        VehicleID:11,
        Make:"Koenigsegg",
        Model:"CC850",
        LicencePlate:"NY00M",

        VehicleType:"CAR",
        SkillType:"SENIOR",
        EstimatedHours:"10",
        PriorityType:"IMMEDIATE",
        
        installerID:null,
        JobID:9,
        tenantID:null,
    },
    {
        VehicleID:12,
        Make: "Jeep",
        Model: "Wrangler",
        LicencePlte:"1",

        VehicleType:"OTHER",
        SkillType:"SENIOR",
        EstimatedHours:"3",
        PriorityType:"STANDARD",
        
        installerID:null,
        JobID:10,
        tenantID:null,
    },
    {
        VehicleID:13,
        Make: "Jeep",
        Model: "Wrangler",
        LicencePlte:"2",

        VehicleType:"OTHER",
        SkillType:"SENIOR",
        EstimatedHours:"3",
        PriorityType:"STANDARD",
        
        installerID:null,
        JobID:10,
        tenantID:null,
    },{
        VehicleID:14,
        Make: "Jeep",
        Model: "Wrangler",
        LicencePlte:"3",

        VehicleType:"OTHER",
        SkillType:"SENIOR",
        EstimatedHours:"3",
        PriorityType:"STANDARD",
        
        installerID:null,
        JobID:10,
        tenantID:null,
    },
    {
        VehicleID:17,
        Make:"Vauxhall",
        Model:"Vivaro",
        LicencePlate:"H4NDBLL",

        VehicleType:"VAN",
        SkillType:"JUNIOR",
        EstimatedHours:"3",
        PriorityType:"STANDARD",
        
        installerID:null,
        JobID:11,
        tenantID:null,
    },
    {
        VehicleID:18,
        Make: "GMC",
        Model: "Sierra",
        LicencePlte:"RLCS1",

        VehicleType:"CAR",
        SkillType:"SENIOR",
        EstimatedHours:"6",
        PriorityType:"IMMEDIATE",
        
        installerID:null,
        JobID:12,
        tenantID:null,
    },
    {
        VehicleID:19,
        Make: "Ford",
        Model: "Transit",
        LicencePlte:"RLCS2",

        VehicleType:"CAR",
        SkillType:"JUNIOR",
        EstimatedHours:"4",
        PriorityType:"IMMEDIATE",
        
        installerID:null,
        JobID:12,
        tenantID:null,
    },
    {
        VehicleID:20,
        Make: "Tesla",
        Model: "Model S",
        LicencePlte:"RLCS3",

        VehicleType:"VAN",
        SkillType:"TRAINEE",
        EstimatedHours:"2",
        PriorityType:"IMMEDIATE",
        
        installerID:12,
        JobID:13,
        tenantID:null,
    },
    {
        VehicleID:21,
        Make: "Honda",
        Model: "Civic",
        LicencePlte:"RLCS4",

        VehicleType:"CAR",
        SkillType:"INTERMEDIATE",
        EstimatedHours:"7",
        PriorityType:"IMMEDIATE",
        
        installerID:9,
        JobID:13,
        tenantID:null,
    },
    {
        VehicleID:22,
        Make: "Ford",
        Model: "F-150",
        LicencePlte:"SR22BUS",

        VehicleType:"BUS",
        SkillType:"TRAINEE",
        EstimatedHours:"20",
        PriorityType:"STANDARD",
        
        installerID:12,
        JobID:14,
        tenantID:null,
    },
    {
        VehicleID:23,
        Make:"Chrysler",
        Model:"300C",
        LicencePlate:"USA1",

        VehicleType:"CAR",
        SkillType:"SENIOR",
        EstimatedHours:"9",
        PriorityType:"IMMEDIATE",
        
        installerID:9,
        JobID:15,
        tenantID:null,
    },
    {
        VehicleID:24,
        Make:"Ford",
        Model:"Fiesta",
        LicencePlate:"L4TE2UNI",

        VehicleType:"CAR",
        SkillType:"TRAINEE",
        EstimatedHours:"3",
        PriorityType:"LOW",
        
        installerID:12,
        JobID:16,
        tenantID:null,
    },
    {
        VehicleID: 25,
        Make: "Toyota",
        Model: "Prius",
        LicencePlate: "SG57ZBH",

        VehicleType: "TAXI",
        SkillType: "JUNIOR",
        EstimatedHours: "3",
        PriorityType: "STANDARD",

        installerID: 11,
        JobID: 4,
        tenantID: null,
    },
]